import * as Yup from "yup";

/** Plano Real — 1º de julho de 1994 */
export const ASSET_MIN_PURCHASE_DATE = new Date(1994, 6, 1);

export const ASSET_MIN_PURCHASE_DATE_MESSAGE =
    "Data deve ser a partir de 01/07/1994 (Plano Real).";

export function yupAssetPurchaseDate(requiredMessage = "Campo obrigatório") {
    return Yup.date()
        .required(requiredMessage)
        .min(ASSET_MIN_PURCHASE_DATE, ASSET_MIN_PURCHASE_DATE_MESSAGE);
}
